var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar7 = function SvgDefaultAvatar7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6 25.2H35.4c-1.7 0-1.5-.6-2.6-.6-1.6 0-2.8 4.1-2.8 6.9 0 1.6.3 2.8 1.3 2.8.7 0 1.2-1 1.6-2.1.3-1.3.7-2 1-2.2.6-.5 2.6-.5 5.4-.5h6.8c-.1.6-.4 1.3-.8 2.3-2.3 5.6-5 11.4-8.1 17.2-1.4 2.6-2.4 3.7-2.4 4.5 0 1 1.2 1.8 2.8 1.8 1.6 0 2.1-1.3 3.7-5 2.8-6.2 4.9-11.4 6.9-17 1.2-3.4 1.9-5.4 1.9-6.5 0-1-.7-1.6-2.5-1.6z"
  })));
};
export default SvgDefaultAvatar7;